// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M3.84 2.533a1.567 1.567 0 0 0-.936.65c-.177.27-.228.461-.226.837.001.287.007.327.074.504.215.565 6.36 15.453 6.424 15.564.042.073.153.209.247.303.201.202.471.348.753.408.352.074.804-.012 1.108-.211.101-.067.654-.6 1.658-1.601l1.506-1.501 1.662 1.655c1.345 1.34 1.692 1.674 1.818 1.746.512.296 1.15.27 1.615-.064.082-.058.441-.402.798-.763.555-.56.662-.68.736-.824.12-.231.166-.43.166-.707 0-.355-.076-.596-.277-.874-.059-.08-.83-.87-1.716-1.755l-1.61-1.607 1.497-1.5c.823-.826 1.53-1.553 1.573-1.616.185-.274.265-.532.266-.85 0-.285-.031-.431-.144-.667a1.572 1.572 0 0 0-.733-.72l-7.787-3.208C7.759 3.856 4.556 2.55 4.464 2.53a1.543 1.543 0 0 0-.624.003m.345 1.513 3.152 7.662 3.135 7.616 1.778-1.776c.978-.976 1.81-1.791 1.85-1.811a.886.886 0 0 1 .696 0c.04.02.93.893 1.98 1.941l1.908 1.906.528-.528.527-.528-1.9-1.902c-2.079-2.08-1.995-1.985-2.017-2.298a.618.618 0 0 1 .042-.3c.051-.138.122-.213 1.832-1.925.978-.98 1.773-1.786 1.767-1.792-.006-.005-3.44-1.422-7.631-3.147-4.191-1.725-7.63-3.143-7.642-3.15-.013-.008-.015.006-.005.032"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const CursorIcon = Icon;
export default CursorIcon;
